export const 사망_표현_LIST = [
  "별세",
  "작고",
  "영면",
  "운명",
  "임종",
  "사망",
  "소천",
  "선종",
  "타계",
  "입적",
  "열반",
  "원적",
  "환원",
] as const;

export const RELIGION_LIST = ["기독교", "천주교", "불교", "무교"] as const;

export const 기독교_직분_LIST = [
  "집사",
  "장로",
  "목사",
  "안수집사",
  "성도",
  "권사",
  "부교",
] as const;

export const 천주교_직분_LIST = ["교우"] as const;

export const 유족_관계_LIST = [
  "대표상주",
  "상주",
  "배우자",
  "아들",
  "딸",
  "부(父)",
  "모(母)",
  "사위",
  "며느리",
  "손",
  "손자",
  "손녀",
  "외손자",
  "외손녀",
  "손부",
  "손서",
  "외손부",
  "외손서",
  "증손자",
  "증손녀",
] as const;
